import { EditableRichText } from "lib/@components/editable/editableRichText"
import { bind } from "lib/@components/binding/bind"
import { FULL_SCREEN_BTN } from "minimals-template/components/editor/editor-buttons"

export function AuthoringEditableRichText({ addBtns = [], ...props }) {
    return <EditableRichText {...props} addBtns={[...addBtns, FULL_SCREEN_BTN]} />
}

export const AuthoringBoundEditableRichText = bind(<AuthoringEditableRichText />, { extract: (v) => v })
